import db from "../db/database";
import { fetchFromBusinessCentral } from "../utils/businessCentralUtils";
import { isOnline } from "./syncService";

// Sincronizar direcciones de clientes desde Business Central
export const syncClientAddresses = async () => {
	if (!isOnline()) {
		return false;
	}

	try {
		// Obtener direcciones del servidor
		const serverAddresses = await fetchFromBusinessCentral("direcciones");

		if (!serverAddresses || serverAddresses.length === 0) {
			console.log("No se encontraron direcciones de clientes en el servidor");
			return true;
		}

		// Mapa para buscar direcciones locales por código rápidamente
		const localAddresses = await db.clientAddresses.toArray();
		const localAddressesByCode = {};
		localAddresses.forEach((address) => {
			if (address.Code) {
				localAddressesByCode[address.Code] = address;
			}
		});

		// Actualizar direcciones existentes y añadir nuevas desde el servidor
		for (const serverAddress of serverAddresses) {
			try {
				const localAddress = localAddressesByCode[serverAddress.Code];

				if (localAddress) {
					// Actualizar dirección existente
					await db.clientAddresses.update(localAddress.id, {
						CustomerNo: serverAddress.CustomerNo,
						Name: serverAddress.Name,
						Ciudad: serverAddress.Ciudad,
						Provincia: serverAddress.Provincia,
						Email: serverAddress.Email || "",
						Teléfono: serverAddress.Teléfono || "",
						lastSynced: new Date(),
					});
				} else {
					// Añadir nueva dirección del servidor
					await db.clientAddresses.add({
						CustomerNo: serverAddress.CustomerNo,
						Code: serverAddress.Code,
						Name: serverAddress.Name,
						Ciudad: serverAddress.Ciudad,
						Provincia: serverAddress.Provincia,
						Email: serverAddress.Email || "",
						Teléfono: serverAddress.Teléfono || "",
						lastSynced: new Date(),
					});
				}
			} catch (error) {
				console.error(
					`Error al sincronizar dirección ${serverAddress.Code}:`,
					error
				);
			}
		}

		console.log(
			`Sincronización de direcciones de clientes completada. Procesadas: ${serverAddresses.length}`
		);
		return true;
	} catch (error) {
		console.error("Error al sincronizar direcciones de clientes:", error);
		return false;
	}
};
